import debounce from 'debounce';
import { useEffect } from 'react';
import { useMarketOrderPriceImpact } from '../../../hooks/useMarketOrderPriceImpact';
import { useTradeFormStore } from '../TradeForm/TradeFormState';

const EXECUTION_PRICE_DEBOUNCE_MS = 500;

export const useSyncExecutionPriceToFormState = (productId: string, size: bigint | undefined) => {
  const setMidPrice = useTradeFormStore((x) => x.setMidPrice);
  const setExecutionPriceLong = debounce(
    useTradeFormStore((x) => x.setExecutionPriceLong),
    EXECUTION_PRICE_DEBOUNCE_MS
  );
  const setExecutionPriceShort = debounce(
    useTradeFormStore((x) => x.setExecutionPriceShort),
    EXECUTION_PRICE_DEBOUNCE_MS
  );

  const { executionPrice: executionPriceLong, midPrice } = useMarketOrderPriceImpact(
    productId,
    'long',
    size || 0n
  );
  const { executionPrice: executionPriceShort } = useMarketOrderPriceImpact(
    productId,
    'short',
    size || 0n
  );

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    if (currentState.midPrice !== midPrice) {
      setMidPrice(midPrice);
    }
  }, [midPrice, setMidPrice]);

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    if (currentState.executionPriceLong !== executionPriceLong) {
      setExecutionPriceLong(executionPriceLong);
    }
  }, [executionPriceLong, setExecutionPriceLong]);

  useEffect(() => {
    const currentState = useTradeFormStore.getState();
    if (currentState.executionPriceShort !== executionPriceShort) {
      setExecutionPriceShort(executionPriceShort);
    }
  }, [executionPriceShort, setExecutionPriceShort]);
};
